'use strict';

/*global initialize*/
/*global services*/
/*global createObjectCallBack*/
/*global isEmpty*/
/*global diffDate*/
/*global addDays*/
function Project() {

  this.init();
}

Project.prototype = $.extend({}, {
  constructor: 'Project',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.project-add', function () {
      _this.showAddForm();
      return false;
    });

    $('body').on('click', '.project-add-form .date-button-options .btn', function () {
      _this.addDaysToDate($(this));

      return false;
    });

    $('body').on('change', '.project-add-form .project-date-from, .project-add-form .project-date-to', function () {
      _this.changeProjectDate();
    });
  },

  //----------------------------------------------------------------------------

  changeProjectDate: function () {
    var _this = this;

    var modal = services.get('modal');

    var $form = modal.contentDOM().find('form');

    var diffDays = 0;
    var fromDate = $form.find('.project-date-from').val();
    var toDate = $form.find('.project-date-to').val();

    if (!isEmpty(fromDate) && !isEmpty(toDate)) {
      diffDays = diffDate(fromDate, toDate) + 1;
    }

    $form.find('.date-diff-days').text(diffDays);

    return _this;
  },

  addDaysToDate: function addDaysToDate($btn) {
    var _this = this;

    var date = new Date();
    if (!isEmpty($btn.data('days'))) {
      date = addDays(date, $btn.data('days'));
    }

    var $input = $btn.closest('.date-button-options-wrapper').find('input:text');
    $input.datepicker('update', date);

    return _this;
  },

  initForm: function initForm() {
    var _this = this;

    var modal = services.get('modal');
    initialize(modal.contentDOM());

    return _this;
  },

  submitForm: function submitForm() {
    var _this = this;

    var modal = services.get('modal');
    var $content = modal.contentDOM();
    var $form = $content.find('form');

    modal.block();
    $.post($form.attr('action'), $form.serialize(), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.close();
        services.get('notifications').viewSaveMessage();

        location.href = res.redirect_url;
      } else if (res.msg === 'NOT_VALID') {
        modal.content(res.data.html);
        _this.initForm();
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  showAddForm: function showAddForm() {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('project.add'),
      saveBtnTitle: services.get('translator').trans('form.create'),
      height: 'auto',
      minHeight: '400px',
      submitCallBack: createObjectCallBack(_this, 'submitForm'),
      width: 'lg',
      form: true,
      modalClass: 'project-add-form',
      keyboardClose: false
    });

    modal.block();
    $.get(services.get('router').path('project'), function (res) {
      modal.unBlock();
      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
        _this.initForm();
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
